import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'; // Hook to access the current location

import FoldersService from '../../../services/FoldersService';

/**
 * DeclaredIssueInfo Component
 * 
 * This component displays the declared issues for a folder.
 */
const DeclaredIssueInfo = () => {
    const { refFolder } = useParams(); // Get the folder number from the URL

    // State to hold declared issue data
    const [data, setData] = useState(null);

    // State to handle loading and error messages
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    /**
     * Fetches the declared issue for the folder.
     * Sets loading state and handles errors.
     * 
     * @returns {Promise<void>} A promise that resolves when the data is fetched
     * @throws {Error} Throws an error if fetching fails
     */
    const fetchData = async () => {
        try {
            // Set loading state to true
            setLoading(true);

            // Fetch the folder based on the folder number
            const folder = await FoldersService.getFolderByNumber(refFolder);

            // If the folder is not found, throw an error
            if (!folder) {
                setError(new Error('Dossier introuvable'));
                return;
            }

            // Set the declared issue data
            setData(folder.declared_issue);
        } catch (error) {
            setError(error?.message || "Une erreur inattendue est survenue");
        } finally {
            setLoading(false);
        }
    };

    // Fetch the data when the component mounts
    useEffect(() => {
        fetchData();
    }, []);

    // Display loading message while fetching data
    if (loading) {
        return (
            <div className="folder-section issues-info">
                <h2>Panne déclarée</h2>
                Chargement...
            </div>
        );
    }

    // Display error message if an error occurred
    if (error) {
        return (
            <div className="folder-section issues-info">
                <h2>Panne déclarée</h2>
                Erreur lors du chargement des données : {error?.message}
            </div>
        );
    }

    // If there is no data, return null
    return (
        <div className="folder-section issues-info">
            <h2>Panne déclarée</h2>
            {data || 'N/A'}
        </div>
    );
};

export default DeclaredIssueInfo;
